<script setup>
import { computed } from 'vue';
import { useToggle } from '@vueuse/core';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';
import { emitter } from 'shared/helpers/mitt';
import { CMD_SNOOZE_CONVERSATION } from 'dashboard/helper/commandbar/events';
import wootConstants from 'dashboard/constants/globals';

import NextButton from 'dashboard/components-next/button/Button.vue';
import DropdownMenu from 'dashboard/components-next/dropdown-menu/DropdownMenu.vue';

const store = useStore();
const { t } = useI18n();

const [showDropdown, toggleDropdown] = useToggle(false);
const closeDropdown = () => toggleDropdown(false);

const currentChat = computed(() => store.getters.getSelectedChat);

// Same rule the resolve dropdown uses for its snooze entry: a pending or
// already snoozed conversation has nothing to snooze.
const isSnoozable = computed(
  () =>
    ![
      wootConstants.STATUS_TYPE.PENDING,
      wootConstants.STATUS_TYPE.SNOOZED,
    ].includes(currentChat.value.status)
);

const menuItems = computed(() =>
  Object.values(wootConstants.SNOOZE_OPTIONS).map(option => ({
    label: t(`COMMAND_BAR.COMMANDS.${option.toUpperCase()}`),
    value: option,
    action: 'snooze',
  }))
);

// `CmdBarConversationSnooze`, mounted by every view that renders this header,
// owns the status write and the custom snooze modal.
const handleSnooze = ({ value }) => {
  closeDropdown();
  emitter.emit(CMD_SNOOZE_CONVERSATION, value);
};
</script>

<template>
  <div class="relative flex items-center">
    <NextButton
      v-tooltip="t('CONVERSATION.CARD_CONTEXT_MENU.SNOOZE.TITLE')"
      :aria-label="t('CONVERSATION.CARD_CONTEXT_MENU.SNOOZE.TITLE')"
      data-testid="conversation-snooze-button"
      :disabled="!isSnoozable"
      icon="i-lucide-moon"
      ghost
      slate
      sm
      @click="toggleDropdown()"
    />
    <DropdownMenu
      v-if="showDropdown"
      v-on-clickaway="closeDropdown"
      :menu-items="menuItems"
      class="top-full mt-0.5 start-0 xl:start-auto xl:end-0 min-w-[11rem]"
      @action="handleSnooze"
    />
  </div>
</template>
